import clsx from 'clsx'

import { CurrencyYenFilledIcon } from '@/components/icons/CurrencyYenFilled'
import { Icon } from '@/components/ui'

export const priceLabel = (
  price: number,
  iconStyle: {
    colorClassName: string
    fontSize: number
  } = {
    colorClassName: 'tw-text-black',
    fontSize: 16,
  }
) => {
  return (
    <span className={clsx('tw-flex tw-items-center')}>
      <Icon
        icon={CurrencyYenFilledIcon}
        className={clsx(iconStyle.colorClassName)}
        size={'md'}
      />
      {price.toLocaleString()}
    </span>
  )
}

export const unsetScrollLock = () => {
  document.documentElement.style.overflow = ''
  document.documentElement.style.paddingRight = ''
}
